'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import UtilisateursContent from './components/UtilisateursContent';

export default function UtilisateursPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/utilisateurs">
        <UtilisateursContent />
      </AppLayout>
    </RouteGuard>
  );
}
